import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchClients, saveClientNote } from '@/lib/clients';

export function ClientCRM() {
  const [query, setQuery] = useState('');
  const [editing, setEditing] = useState<string | null>(null);
  const [note, setNote] = useState('');
  const qc = useQueryClient();
  const { data = [], isLoading } = useQuery({ queryKey: ['owner-clients'], queryFn: fetchClients });
  const save = useMutation({
    mutationFn: ({ phone, value }: { phone: string; value: string }) => saveClientNote(phone, value),
    onSuccess: async () => { setEditing(null); await qc.invalidateQueries({ queryKey: ['owner-clients'] }); }
  });
  const needle = query.trim().toLowerCase();
  const rows = data.filter((row) => !needle || `${row.name} ${row.phone} ${row.note}`.toLowerCase().includes(needle));

  return <section className="mnc-admin-panel">
    <div className="mnc-admin-panel-head"><div><span className="mnc-eyebrow">CRM</span><h2>Клиенты</h2></div><span className="mnc-admin-count">{data.length}</span></div>
    <label className="mnc-field">Поиск<input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Имя, телефон или заметка" /></label>
    {isLoading && <p className="mnc-muted">Загружаем клиентов…</p>}
    <div className="mnc-client-grid">
      {rows.map((client) => <article className="mnc-client-card" key={client.phone}>
        <div><b>{client.name}</b><a href={`tel:+${client.phone}`}>+{client.phone}</a></div>
        <span className="mnc-client-segment">{client.completed >= 3 ? 'Постоянный' : client.completed >= 2 ? 'Повторный' : client.completed === 1 ? 'Был один раз' : 'Новый'}</span>
        <dl><div><dt>Визитов</dt><dd>{client.completed}</dd></div><div><dt>Отмен</dt><dd>{client.cancelled}</dd></div><div><dt>Выручка</dt><dd>{client.revenue.toLocaleString('ru-RU')} ₽</dd></div></dl>
        {editing === client.phone ? <div className="mnc-client-note"><textarea value={note} onChange={(event) => setNote(event.target.value)} maxLength={2000} /><button className="mnc-btn mnc-btn-sm" disabled={save.isPending} onClick={() => save.mutate({ phone: client.phone, value: note })}>Сохранить</button></div>
          : <button className="mnc-linklike" onClick={() => { setEditing(client.phone); setNote(client.note); }}>{client.note || 'Добавить заметку'}</button>}
      </article>)}
    </div>
    {!isLoading && rows.length === 0 && <div className="mnc-admin-empty"><span>Клиенты появятся после первой записи.</span></div>}
  </section>;
}
